<template>
  <div class="container" v-if="model">
    <common-head></common-head>
    <div class="inner">
      <div class="dz-detail-page">
        <div class="basic-info">
          <div class="img">
            <template v-if="model.Cover">
              <img :src="model.Cover" />
            </template>
            <template v-else>
              <img src="/static/img/np-img.png" />
            </template>
          </div>
          <div class="info">
            <div class="bkname">{{ model.Name }}</div>
            <div class="para-list">
              <ul>
                <li>
                  作者：
                  <el-tooltip placement="top">
                    <template #content> {{ model.Author }}</template>
                    <span>{{ model.Author }}</span>
                  </el-tooltip>
                </li>
                <li>
                  出版社：
                  <el-tooltip placement="top">
                    <template #content> {{ model.Publisher }}</template>
                    <span>{{ model.Publisher }}</span>
                  </el-tooltip>
                </li>
                <li>ISBN：{{ model.Isbn }}</li>
                <li>出版时间：{{ model.PublishTime }}</li>
                <li>点击量：{{ browseCount }} 次</li>
                <li>上架时间：{{ model.CreatedTime }}</li>
                <li>
                  分类：
                  <a :href="'/categry?form=' + model.ProductType">{{
                    model.ProductTypeText
                  }}</a>
                  >
                  <a
                    :href="
                      '/categry?form=' +
                      model.ProductType +
                      '&node=' +
                      model.CategryFirstId
                    "
                    >{{ model.CategryFirstName }}</a
                  >
                  >
                  <a
                    :href="
                      '/categry?form=' +
                      model.ProductType +
                      '&node=' +
                      model.CategryFirstId +
                      '&menu=' +
                      model.CategrySecondId
                    "
                    >{{ model.CategrySecondName }}</a
                  >
                </li>
              </ul>
            </div>
            <div class="opt-info" v-if="flag == 1 || flag == 2">
              <el-button type="warning" @click="changePlay()">
                <template v-if="isPlay === true">
                  <span class="icon iconfont icon-zanting1"></span>暂停播放
                </template>
                <template v-else>
                  <span class="icon iconfont icon-bofang"></span>立即播放
                </template>
              </el-button>
              <el-button
                :type="model.IsCollect ? 'danger' : 'warning'"
                @click="$fun.addCollect(model)"
                >{{ model.IsCollect ? "移除书架" : "加入书架" }}</el-button
              >
              <el-popover
                placement="bottom"
                width="160"
                trigger="click"
                popper-class="phone-btn"
                class="button-code"
              >
                <slot>
                  <div class="code-info">
                    <div ref="qrCodeDiv" id="qrCode"></div>
                    <div class="ti">手机扫码收听</div>
                  </div>
                </slot>
                <el-button slot="reference" @click="GoToOpt()">
                  <span class="icon iconfont icon-shouji"></span>
                  手机收听
                </el-button>
              </el-popover>
            </div>
            <div class="opt-info" v-if="flag == 0">
              <el-button type="warning"  
                >加入心愿单</el-button
              >
              <el-button type="warning" 
                >试读</el-button
              >
            </div>
          </div>
        </div>
        <div class="intro-group">
          <el-tabs>
            <el-tab-pane label="书籍简介" name="0" v-if="model.Introduction">
              <div
                class="contents"
                :class="showDescript ? 'open' : ''"
                v-html="model.Introduction"
              ></div>
              <div
                class="more"
                v-if="model.Introduction.length > 489"
                @click="showDescript = !showDescript"
              >
                <span
                  class="icon iconfont"
                  :class="
                    showDescript
                      ? 'icon-sanjiaoxingjiantou_xiangshang'
                      : 'icon-sanjiaoxingjiantou_xiangyou'
                  "
                ></span>
                {{ showDescript ? "收起" : "展开" }}
              </div>
            </el-tab-pane>
            <el-tab-pane label="编者推荐" name="1" v-if="model.Remark">
              <div
                class="contents"
                :class="showRemark ? 'open' : ''"
                v-html="model.Remark"
              ></div>
              <div
                class="more"
                v-if="model.Remark.length > 489"
                @click="showRemark = !showRemark"
              >
                <span
                  class="icon iconfont"
                  :class="
                    showRemark
                      ? 'icon-sanjiaoxingjiantou_xiangshang'
                      : 'icon-sanjiaoxingjiantou_xiangyou'
                  "
                ></span>
                {{ showRemark ? "收起" : "展开" }}
              </div>
            </el-tab-pane>
            <el-tab-pane label="内容简介" name="2" v-if="model.CONTENT">
              <div
                class="contents"
                :class="showContent ? 'open' : ''"
                v-html="model.CONTENT"
              ></div>
              <div
                class="more"
                v-if="model.CONTENT.length > 489"
                @click="showContent = !showContent"
              >
                <span
                  class="icon iconfont"
                  :class="
                    showContent
                      ? 'icon-sanjiaoxingjiantou_xiangshang'
                      : 'icon-sanjiaoxingjiantou_xiangyou'
                  "
                ></span>
                {{ showContent ? "收起" : "展开" }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="chapter-con">
          <div class="chapter-cc">
            <div class="chapter-hd">
              <div class="title">
                节目<span>({{ audioData.length }})</span>
              </div>
            </div>
            <div class="chapter-bd">
              <div class="chapter-list">
                <div
                  class="item"
                  v-for="(item, index) in audioData"
                  :class="{ active: index === audioIndex && isPlay }"
                >
                  <div class="order-num">{{ index + 1 }}</div>
                  <div class="pl-label" @click="changeAudio(index)">
                    <template v-if="index === audioIndex && isPlay">
                      <img src="/static/img/wave.gif" class="bf-icon" />
                    </template>
                    <template v-else>
                      <span class="icon iconfont icon-bofang"></span>
                    </template>
                    {{ item.NAME }}
                  </div>
                  <div class="listen">
                    <span class="icon iconfont icon-shiting"></span
                    >{{ item.ReadTotal }}
                  </div>
                  <div class="duration-s">
                    <span class="icon iconfont icon-lishijilu"></span
                    >{{ minuteTime(item.DURATION) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hotcc-r">
            <hot-recom></hot-recom>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
    <div class="player-float" ref="playerLeft" v-if="audioData.length > 0 && flag !== 0">
      <template v-if="audioData[audioIndex].AudioUrl">
        <audio
          class="myAudio"
          ref="audio"
          :autoplay="isAuto"
          :src="audioData[audioIndex].AudioUrl"
          @play="play"
          @pause="pause"
          @canplay="oncanplay"
          @timeupdate="ontimeupdate"
          @ended="onended"
        ></audio>
      </template>
      <template v-else><img src="/static/img/np-img.png" /></template>
      <div class="inner">
        <div class="pl-btns">
          <div
            class="icon iconfont icon-houtui back-btn"
            @click="changeAudio(audioIndex - 1)"
          ></div>
          <div
            :class="
              'play-btn icon iconfont ' +
              (isPlay === true ? 'icon-zanting' : 'icon-24gf-playCircle')
            "
            @click="changePlay()"
          ></div>
          <div
            class="icon iconfont icon-kuaijin forward-btn"
            @click="changeAudio(audioIndex + 1)"
          ></div>
        </div>
        <div class="pl-progress">
          <div class="s-img">
            <template v-if="audioData[audioIndex].COVER">
              <audio
                :src="audioData[audioIndex].COVER"
              ></audio>
            </template>
            <template v-else><img src="/static/img/np-img.png" /></template>
          </div>
          <div class="pl-ot-info">
            <div class="gather-name">{{ audioData[audioIndex].NAME }}</div>
            <div class="progress-container">
              <div class="times">
                <span class="current-time">{{
                  $refs.audio ? hourTime($refs.audio.currentTime) : "00:00:00"
                }}</span
                >/<span class="duration-time">{{
                  hourTime(audioData[audioIndex].DURATION)
                }}</span>
              </div>
              <div class="progress-c">
                <div
                  class="progress-w-all"
                  ref="progress"
                  @click.self="changeProgress"
                >
                  <div
                    class="back-g"
                    :style="{ width: pointEX + 'px' }"
                    @click="changeProgress"
                  ></div>
                  <div
                    class="pointer"
                    :style="{ left: pointEX + 'px' }"
                    ref="slideBtn"
                    @mousedown="onmousedown"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bs-voice">
          <el-select
            v-model="multipleText"
            placeholder="倍数"
            class="multiple"
            size="mini"
            @change="changeMultiple"
          >
            <el-option
              v-for="item in multipleData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="AdjVolume">
            <template v-if="volume === 0">
              <span
                class="icon iconfont icon-Mute"
                @click="changeVolume"
              ></span>
            </template>
            <template v-else>
              <span
                class="icon iconfont icon-Volume"
                @click="changeVolume"
              ></span>
            </template>
            <div class="volume-progress">
              <div class="volume-all" ref="volumeWrap">
                <div class="bk-bg" :style="{ width: vcslide + 'px' }"></div>
                <div
                  class="pointer"
                  ref="vcSlideBtn"
                  :style="{ left: vcslideBtn + 'px' }"
                  @mousedown.prevent="volumeDrag"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import HotRecom from "common/other/HotRecom";
import QRCode from "qrcodejs2";
import { f } from "vue-carousel-3d";
import { Alert } from 'element-ui';
export default {
  name: "ysDetail",
  components: {
    CommonHead,
    CommonFoot,
    HotRecom,
  },
  data() {
    return {
      showDescript: false,
      showRemark: false,
      showContent: false,
      multipleText: "1.0",
      multipleData: [
        { value: "0.5", label: "0.5X" },
        { value: "0.75", label: "0.75X" },
        { value: "1.0", label: "1.0X" },
        { value: "1.25", label: "1.25X" },
        { value: "1.5", label: "1.5X" },
        { value: "1.75", label: "1.75X" },
        { value: "2.0", label: "2.0X" },
        { value: "2.5", label: "2.5X" },
        { value: "3.0", label: "3.0X" },
      ],
      pointBX: 0, // 开始位置
      pointEX: 0, // 结束位置
      volume: 0.5,
      vcslide: 65,
      vcslideBtn: 65,
      vcsdW: 0,
      translateX: 0,
      browseCount: 0,
      model: undefined,
      audioId: "",
      flag: 5,
      audioIndex: 0,
      audioData: [],
      isPlay: false,
      isAuto: false,
    };
  },
  mounted: function () {
    
    this.$bti
      .GetSoundBookInfo({
        ID: this.$route.params.id,
        ORGID: this.$fun.getMember().orgId,
      })
      .then((res) => {
        if (res.code != 1 || res.data.Model == null) {
          this.$router.push({ name: "Home", params: { message: res.data } });
          return;
        }
        this.model = res.data.Model;
        this.audioId = res.data.Audio ? res.data.Audio.ID : "";
        this.$bti.GetAddXyd({ BOOKID: this.model.Id ,ISDELETED: this.model.ProductType}).then((res) => {
          if (res.code == 1) {
            this.flag = res.data
            this.GetQrcode();
          }
        });
        this.loadData();
        var own = this;
        this.$fun.browse(this.model.Id, this.model.ProductType, function (res) {
          own.browseCount = res.data;
        });
      });
  },
  methods: {
    loadData() {
      this.$bti.GetSoundBookChildList({ id: this.model.Id }).then((res) => {
        if (res.code != 1) {
          return;
        }
        this.audioData = res.data;
        this.audioIndex = 0;
        for (var i = 0; i < this.audioData.length; i++) {
          if (this.audioData[i].ID == this.audioId) {
            this.audioIndex = i;
          }
        }
      });
    },
    changePlay: function () {
      if (!this.$fun.isLogin()) {
        this.$router.replace({
          path: "/login",
          query: { redirect: this.$router.currentRoute.fullPath },
        });
        return;
      }
      if (this.$refs.audio.paused) {
        this.$refs.audio.play();
        this.changeRead();
      } else {
        this.$refs.audio.pause();
      }
    },
    changeAudio: function (val) {
      if (this.flag == 0) {
        return this.$message.error("该书籍未购买!");
      }
      if (!this.$fun.isLogin()) {
        this.$router.replace({
          path: "/login",
          query: { redirect: this.$router.currentRoute.fullPath },
        });
        return;
      }
      if (this.audioIndex == val && this.isPlay) {
        return;
      }
      this.audioIndex = val;
      this.renderAudio();
      var audio = this.$refs.audio;
      if (this.$refs.audio.paused) {
        setTimeout(function () {
          audio.play();
        }, 200);
      }
    },
    renderAudio: function () {
      if (this.audioIndex < 0) {
        this.audioIndex = this.audioData.length - 1;
      }
      if (this.audioIndex > this.audioData.length - 1) {
        this.audioIndex = 0;
      }
      this.isAuto = true;
      this.changeRead();
    },
    changeRead: function () {
      this.$fun.browse(this.audioData[this.audioIndex].ID, 21);
      this.audioData[this.audioIndex].ReadTotal++;
    },
    onended: function () {
      this.audioIndex = this.audioIndex + 1;
      this.renderAudio();
      return false;
    },
    oncanplay: function () {
      this.$refs.audio.playbackRate = this.multipleText;
    },
    // 播放时间发生改变
    ontimeupdate: function () {
      if (!this.$refs.audio) {
        return;
      }
      this.changePoint();
    },
    // 激活圆点
    onmousedown: function (event) {
      event = event || window.event;
      this.pointBX = event.clientX - this.$refs.slideBtn.offsetLeft;
      document.onmousemove = this.onmousemove;
      document.onmouseup = this.onmouseup;
    },
    // 拖动进度圆点
    onmousemove: function (event) {
      event = event || window.event;
      var layerX = event.clientX - this.pointBX;
      if (layerX < 0) layerX = 0;
      if (
        layerX >
        this.$refs.progress.clientWidth - this.$refs.slideBtn.offsetWidth
      ) {
        layerX =
          this.$refs.progress.clientWidth - this.$refs.slideBtn.offsetWidth;
      }
      this.$refs.audio.currentTime = (layerX / 552) * this.$refs.audio.duration;
      this.changePoint();
      return false;
    },
    onmouseup: function () {
      document.onmousemove = null;
    },
    // 进度条点击快进或后退
    changeProgress: function (event) {
      event = window.event || event;
      this.$refs.audio.currentTime =
        ((event.layerX > 5 ? event.layerX - 5 : event.layerX) /
          this.$refs.progress.clientWidth) *
        this.$refs.audio.duration;
      this.changePoint();
    },
    changePoint() {
      this.pointEX =
        (this.$refs.audio.currentTime / this.$refs.audio.duration) *
        this.$refs.progress.clientWidth;
    },
    pause: function () {
      this.isPlay = false;
    },
    play: function () {
      this.isPlay = true;
    },
    // 转换小时、分钟、秒
    minuteTime: function (value) {
      var mis = this.toTwo(parseInt((value % 3600) / 60));
      var sec = this.toTwo(parseInt(value % 60));
      var str = mis + ":" + sec;
      return str;
    },
    // 转换小时、分钟、秒
    hourTime: function (value) {
      var hours = this.toTwo(parseInt(value / 3600));
      var mis = this.toTwo(parseInt((value % 3600) / 60));
      var sec = this.toTwo(parseInt(value % 60));
      var str = hours + ":" + mis + ":" + sec;
      return str;
    },
    toTwo: function (value) {
      return value < 10 ? "0" + value : value;
    },
    // 倍数设置
    changeMultiple: function (val) {
      this.multipleText = val;
      this.$refs.audio.playbackRate = this.multipleText;
    },
    volumeDrag: function (event) {
      event = event || window.event;
      this.vcsdW = event.clientX - this.$refs.vcSlideBtn.offsetLeft;
      // console.log(this.vcsdW);
      document.onmousemove = this.volumeMove;
      document.onmouseup = this.volumeUp;
    },
    volumeMove: function (event) {
      event = event || window.event;
      this.translateX = event.clientX - this.vcsdW;
      if (this.translateX < 0) this.translateX = 0;
      if (
        this.translateX >
        this.$refs.volumeWrap.clientWidth - this.$refs.vcSlideBtn.offsetWidth
      ) {
        this.translateX =
          this.$refs.volumeWrap.clientWidth - this.$refs.vcSlideBtn.offsetWidth;
      }
      // 滑块
      this.vcslideBtn = this.translateX;
      this.vcslide = this.translateX;
      var k = this.vcslide / 120;
      this.volume = k;
      this.$refs.audio.volume = this.volume;
      // 取消默认事件，不选中文字
      return false;
    },
    volumeUp: function () {
      //释放圆点拖动
      document.onmousemove = null;
    },
    changeVolume: function () {
      var k = this.volume;
      if (k > 0) {
        this.volume = 0;
        this.vcslide = 0;
        this.vcslideBtn = 0;
      } else {
        this.volume = 1;
        this.vcslide = 130;
        this.vcslideBtn = 120;
      }
      this.$refs.audio.volume = this.volume;
    },
    GoToOpt: function () {
      if (!this.$fun.isLogin()) {
        window.location.href =
          "/login?redirect=/detail/ysDetail/" + this.$route.params.id;
        return;
      }
    },
    GetQrcode: function () {
      if (!this.$fun.isLogin()) {
         return;
      }
      this.$nextTick(() => {
        let mobileServer = this.http.GetOrgInfo().Domain.replace('://mr', '://mm');
        let data = mobileServer.slice(0,mobileServer.lastIndexOf(':')) + ":" + this.$bti.MobilePort + "/YssShow?Id=" + this.$route.params.id;
        let qrcodeCreater = new QRCode(this.$refs.qrCodeDiv, {
          text: data,
          width: 130,
          height: 130,
          colorDark: "#333333", // 二维码颜色
          colorLight: "#ffffff", // 二维码背景色
          correctLevel: QRCode.CorrectLevel.M, // 容错率，L/M/H
        });
        qrcodeCreater._el.title = "";
      });
    },
  },
};
</script>

<style lang="css" scoped>
.dz-detail-page {
  position: relative;
  background: #fff;
  padding: 50px 0px 50px 50px;
  margin-bottom: 50px;
}
.basic-info:after,
.basic-info .para-list ul:after,
.chapter-con:after,
.chapter-con .chapter-cc .chapter-hd,
.chapter-list:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}
.basic-info {
  margin-right: 50px;
}
.basic-info .img {
  float: left;
  width: 197px;
  height: 267px;
  box-shadow: 0px 0px 5px #ccc;
}
.basic-info .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.basic-info .info {
  position: relative;
  float: right;
  width: 863px;
  width: calc(100% - 237px);
  min-height: 267px;
}
.basic-info .bkname {
  font-size: 24px;
  color: #252525;
  font-weight: bold;
}
.basic-info .para-list {
  padding: 20px 0;
}
.basic-info .para-list ul li {
  float: left;
  width: 50%;
  font-size: 18px;
  padding: 5px 25px 5px 0px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.basic-info .opt-info {
  position: relative;
  bottom: 0px;
  left: 0;
}
.basic-info .opt-info .el-button {
  font-weight: bold;
}
.basic-info .opt-info .el-button .icon {
  padding-right: 5px;
}
.basic-info .opt-info .button-code {
  padding-left: 10px;
}
.code-info {
  width: 134px;
  text-align: center;
}
.code-info img {
  width: 134px;
  height: 134px;
  object-fit: cover;
}
.code-info .ti {
  padding-top: 10px;
  color: #fff;
}
.intro-group {
  padding: 40px 0 20px 0px;
  margin-right: 50px;
}
.chapter-con {
  position: relative;
  min-height: 840px;
}
.chapter-con .chapter-cc {
  float: left;
  width: 688px;
}
.chapter-con .chapter-cc .chapter-hd {
  position: relative;
  height: 52px;
  line-height: 52px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid #e4e7ed;
  visibility: visible;
  overflow: inherit;
}
.chapter-con .chapter-cc .chapter-hd .title {
  float: left;
  width: auto;
  height: 52px;
  color: #303133;
  visibility: visible;
  border-bottom: 4px solid #ed7d31;
}
.chapter-hd .title span {
  color: #999;
  padding-left: 10px;
}
.chapter-con .chapter-cc .chapter-hd .opt-set {
  position: absolute;
  right: 0;
  top: 0;
  visibility: visible;
  font-weight: normal;
  cursor: pointer;
}
.chapter-con .chapter-cc .chapter-bd {
  padding: 15px;
  margin-bottom: 15px;
}
.chapter-list .item {
  float: left;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.chapter-list .item a {
  font-size: 14px;
  color: #666;
}
.hotcc-r {
  position: absolute;
  right: 0;
  top: auto;
  width: 408px;
  height: 820px;
  background: #f6f6f6;
}
.chapter-list .item .order-num {
  color: #999;
  width: 25px;
  text-align: center;
}
.chapter-list .item .pl-label {
  width: 72%;
  padding-left: 15px;
  padding-right: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}
.chapter-list .item .pl-label .icon {
  font-size: 12px;
  padding-right: 5px;
}
.chapter-list .item.active .pl-label {
  color: #ed7d31;
}
.chapter-list .item.active .pl-label .bf-icon {
  margin-right: 7px;
}
.chapter-list .item .listen,
.chapter-list .item .duration-s {
  width: 85px;
  color: #999;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: right;
}
.chapter-list .item .listen .icon,
.chapter-list .item .duration-s .icon {
  padding-right: 6px;
}
.chapter-list .item .duration-s {
  padding-left: 25px;
}
.player-float {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 121px;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
}
.player-float .inner {
  position: relative;
  z-index: 11111;
}
.player-float .inner,
.pl-btns,
.pl-progress,
.bs-voice,
.AdjVolume {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.pl-btns {
  width: 196px;
}
.back-btn,
.forward-btn {
  font-size: 30px;
  color: #fff;
  cursor: pointer;
}
.pl-btns .play-btn {
  position: relative;
  width: 74px;
  height: 74px;
  font-size: 82px;
  color: #ed7d31;
  background: #fff;
  border-radius: 100%;
  line-height: 78px;
  text-align: left;
  cursor: pointer;
}
.pl-btns .play-btn:before {
  position: absolute;
  left: -4px;
  top: -2px;
}
.pl-progress .s-img {
  width: 67px;
  height: 81px;
}
.pl-progress .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.pl-btns .icon-zanting:before {
  font-size: 86px;
  left: -6px;
}
.pl-progress {
  width: 644px;
}
.pl-progress .pl-ot-info {
  position: relative;
  width: 552px;
}
.pl-progress .pl-ot-info .gather-name {
  width: 100%;
  font-size: 16px;
  color: #fff;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 10px;
}
.progress-container .times {
  text-align: right;
  color: #cacaca;
  font-size: 16px;
}
.progress-container .times .current-time {
  color: #ea7f31;
}
.progress-container .progress-c {
  position: relative;
  margin-top: 6px;
  width: 100%;
  background: #abacad;
  height: 4px;
  border-radius: 4px;
  cursor: pointer;
}
.progress-container .progress-w-all {
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}
.progress-container .progress-w-all .back-g {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  height: 100%;
  border-radius: 4px;
  background: #e08648;
}
.progress-container .progress-w-all .pointer {
  width: 10px;
  height: 10px;
  background: #f59a23;
  border-radius: 100%;
  position: absolute;
  top: -3px;
  left: 0px;
}
.bs-voice {
  width: 269px;
}
.bs-voice .multiple {
  width: 85px;
  height: 26px;
}
.AdjVolume {
  width: 175px;
  color: #fff;
  padding-left: 10px;
}
.AdjVolume .icon {
  font-size: 26px;
  cursor: pointer;
}
.volume-progress {
  width: 130px;
  background: #abacad;
  height: 4px;
  border-radius: 2px;
  cursor: pointer;
}
.volume-progress .volume-all {
  position: relative;
  width: 100%;
  height: 100%;
}
.volume-progress .volume-all .bk-bg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  height: 100%;
  border-radius: 2px;
  background: #ffffff;
}
.volume-progress .volume-all .pointer {
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 100%;
  position: absolute;
  top: -3px;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/ysDetail.vue